// extracted by mini-css-extract-plugin
var _1 = "BanvasMouseCursor__custom-tenframe-toggle-strike-right--ZywNW";
var _2 = "BanvasMouseCursor__expanding-ew--v2xNK";
var _3 = "BanvasMouseCursor__expanding-nesw--yjGqm";
var _4 = "BanvasMouseCursor__expanding-ns--vCANV";
var _5 = "BanvasMouseCursor__expanding-nwse--Boa1i";
var _6 = "BanvasMouseCursor__grab--o6YRM";
var _7 = "BanvasMouseCursor__grabbing--xMCRn";
var _8 = "BanvasMouseCursor__pointer--ToSRn";
export { _1 as "custom-tenframe-toggle-strike-right", _2 as "expanding-ew", _3 as "expanding-nesw", _4 as "expanding-ns", _5 as "expanding-nwse", _6 as "grab", _7 as "grabbing", _8 as "pointer" }
